import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { UpgradeModule } from '@angular/upgrade/static';
import { CustomModule } from 'angular/custom/custom.module';
import {
    authServiceProvider,
    utilServiceProvider
} from 'angular/angularjs-upgraded.providers';
import { FormsModule } from '@angular/forms';
import { RestResourceModule } from 'angular/resources/rest-resource.module';
import { ModalModule } from 'ngx-bootstrap/modal';
import { Growl } from 'angular/custom/services/growl.service';
import { StorageModule } from 'angular/storage/storage.module';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';
import { MultiYearModule } from 'angular/auctions/multi-year/multi-year.module';
import { CollapseModule } from 'ngx-bootstrap';

registerLocaleData(localeDe, 'de', localeDeExtra);

@NgModule({
    imports: [
        BrowserModule,
        CustomModule,
        FormsModule,
        RestResourceModule,
        ModalModule.forRoot(),
        CollapseModule.forRoot(),
        MultiYearModule,
        StorageModule
    ],
    providers: [
        authServiceProvider,
        utilServiceProvider,
        Growl,
        { provide: LOCALE_ID, useValue: 'de' }
    ]
})
export class AppModule {
    constructor(private upgrade: UpgradeModule) {}
    ngDoBootstrap() {
        this.upgrade.bootstrap(document.body, ['app'], { strictDi: true });
    }
}
